import React, { useEffect, useState,  useCallback } from "react";
import {
  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  CircularProgress,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import ExpandMoreIcon from "../assets/icons/ExpandMoreIcon.png";
import MinusIcon from "../assets/icons/MinusIcons.png";
import uploadIcon from "../assets/icons/uploadIcon.png";
import { fetchBulkCVEs, fetchCVE } from "../actions/epssAction.js";
// import "../firebase.js";
import {
  CenteredTableContainer,
  StyledTable,
  StyledTableHeadCell,
  StyledTableBodyCell,
  ToggleIconButton,
  BulkCustomAccordionDetails,
  BulkCustomTypography,
  BulkCustomAccordionSummary,
  BulkCustomAccordion,
  IconImage,
  BulkUploadInputLabel,
  DownloadLinkLabel,
  UploadButton,
  DownloadLinks,
  BulkScoreContainer,
  ReferencesContainer,
  ReferenceItem,
  ReferenceLink,
  AccordionSummaryValues,
  StyledTableRow,
  SingleCveErrorText,
  BulkCveErrorText,
  NoUnderlineLink,
} from "../assets/styles/bulkCveStyledComponents.js";
import leftArrowIcon from "../assets/icons/leftArrowIcon.png";
import downArrowIcon from "../assets/icons/downArrowIcon.png";
import {
  ButtonGroupStyled,
  CveTitleText,
  FetchButton,
  IconWrapper,
  InputField,
  MainContentBox,
  SingleCveScoreContainer,
  StyledButton,
} from "../assets/styles/singlecveStyledComponent.js";
import HeaderContainer from "./HeaderContainer.js";
// import firebase from "firebase/compat/app";
import CancelIcon from "@mui/icons-material/Cancel";
// import { getAuth, signInWithCustomToken } from "firebase/auth";
import CSV_template from "../assets/csv/CSV_template.csv";
import Excel_template from "../assets/csv/Excel_template.xlsx";
// import FirebaseUIComponent from "./FirebaseUIComponent.js";
// import Cookies from "js-cookie";
import { POST_API } from "../utils/api.js";
import { API_DOMAIN } from "../utils/domain.js";
import { useLocation, useNavigate } from "react-router-dom";
import {  BetaText, HeaderBoxNew } from "../assets/styles/MainComponent.js";
import {
  TextContainer,
  TitleText,
  SubTitle,
} from "../assets/styles/MainComponent.js";

// Commented out Firebase authentication dialog - not currently in use
// const emails = ["username@gmail.com", "user02@gmail.com"];
// function SimpleDialog(props) {
//   const { onClose, selectedValue, open } = props;

//   const handleClose = () => {
//     onClose(selectedValue);
//   };

//   return (
//     <Dialog
//       onClose={handleClose}
//       open={open}
//       className="firebase-signin-popup"
//       sx={{
//         "& .MuiPaper-root": {
//           minWidth: "30vw",
//         },
//         "& .MuiDialogTitle-root": {
//           display: "flex",
//           flexDirection: "row",
//           justifyContent: "space-between",
//           alignItems: "center",
//         },
//       }}
//     >
//       <DialogTitle>
//         <Typography
//           sx={{
//             fontFamily: "Noto Sans",
//             letterSpacing: "-0.16px",

//             "@media (max-width: 426px)": {
//               width: "321px",
//               fontSize: "10px",
//               lineHeight: "13px",
//               letterSpacing: "1.11px",
//             },
//           }}
//         >
//           Sign In
//         </Typography>
//         <IconButton onClick={handleClose}>
//           <CancelIcon />
//         </IconButton>
//       </DialogTitle>
//       <DialogContent>
//         <FirebaseUIComponent open={open} />
//       </DialogContent>
//       <DialogActions>
//         {/* <Button onClick={handleClose} color="error" variant="outlined" >
//           Close
//         </Button> */}
//       </DialogActions>
//     </Dialog>
//   );
// }

// SimpleDialog.propTypes = {
//   onClose: PropTypes.func.isRequired,
//   open: PropTypes.bool.isRequired,
//   selectedValue: PropTypes.string.isRequired,
// };

const MainComponent = () => {
  const [state, setState] = useState({
    tabValue: 0,
    cve_id: "",
    singleCveResponse: null,
    bulkCveResponse: null,
    expanded: false,
    expandedIndex: null,
    error: "",
    singleCveExpandedIndex: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    showScoreContainer: false,
    isBulkFetching: false,
    isSingleFetching: false,
    openSections: {},
    expandedAccordions: {},
    selectedFile: null,
    singleCveError: "",
    bulkCveError: "",
    isUserLoggedIn: false,
  });
  const location = useLocation();
  const navigate = useNavigate();

  // Use URLSearchParams to extract the 'cve-tab' query parameter

  const handleBulkAccordionChange = useCallback((index, key) => {
    setState((prevState) => ({
      ...prevState,
      expandedAccordions: {
        ...prevState.expandedAccordions,
        [index]: {
          ...prevState.expandedAccordions[index],
          [key]: !prevState.expandedAccordions[index]?.[key],
        },
      },
    }));
  }, []);

  const handleFetch = useCallback(async () => {
    if (state.cve_id.trim() === "") {
      setState((prevState) => ({
        ...prevState,
        singleCveError: "Please enter a CVE ID",
      }));
      return;
    }

    setState((prevState) => ({
      ...prevState,
      singleCveError: "",
      isSingleFetching: true,
      expandedIndex: null,
      expandedAccordions: {},
    }));

    try {
      const response = await fetchCVE(state.cve_id);

      if (response.success) {
        setState((prevState) => ({
          ...prevState,
          singleCveResponse: response.data,
          isSingleFetching: false,
          expandedIndex: 0,
          expandedAccordions: {
            0: {
              severity: true,
              summary: true,
              references: true,
              migration_patches: true,
              exploits: true,
              vector: true,
              cwe_id: true,
            }
          },
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          singleCveError: response.message || "Failed to fetch data",
          isSingleFetching: false,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        singleCveError: "An error occurred while fetching data",
        isSingleFetching: false,
      }));
    }
  }, [state.cve_id]);

  useEffect(() => {
    if (state.cve_id.trim() !== "") {
      setState((prevState) => ({
        ...prevState,
        singleCveError: "",
        singleCveResponse: null,
        expandedIndex: null,
        expandedAccordions: {},
      }));
    }
  }, [state.cve_id]);

  // useEffect(() => {
  //   // Check if the authToken exists in the cookie
  //   const token =   Cookies.get("_t");

  //   if (token) {
  //     // Get the Firebase Auth instance
  //     // const auth = getAuth(

  //     // );

  //     // Sign in with the custom token
  //     // signInWithCustomToken(auth, token)  // Correctly using the modular API
  //     POST_API(`${API_DOMAIN}/auth/github/verify-token`, {
  //       idToken: token,
  //     })
  //       .then((res) => {
  //         setState((prev) => ({ ...prev, isUserLoggedIn: true }));
  //         // console.log("User authenticated:", userCredential.user);
  //         // Set the authenticated user or proceed further
  //       })
  //       .catch((error) => {
  //         // Handle authentication errors (e.g., invalid or expired token)
  //         console.error("Error verifying token:", error);
  //         setState((prev) => ({ ...prev, isUserLoggedIn: false }));
  //       });
  //   } else {
  //     console.log("No authToken found in cookies");
  //     setState((prev) => ({ ...prev, isUserLoggedIn: false }));
  //   }
  // }, [state.tabValue]);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const cveTab = queryParams.get("cve-tab"); // This will return 'single-cve' if present
    console.log("cveTab:", cveTab);
    if (cveTab === "bulk-cve") {
      setState((prevState) => ({
        ...prevState,
        tabValue: 1,
      }));
    }
    if (cveTab === "single-cve") {
      setState((prevState) => ({
        ...prevState,
        tabValue: 0,
      }));
    }
  }, []);
  // Commented out Firebase dialog state - not currently in use
  // const [open, setOpen] = React.useState(false);
  // const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = (value) => {
  //   setOpen(false);
  //   setSelectedValue(value);
  // };

  const handleExpandClick = (index) => {
    setState((prevState) => {
      const newExpandedIndex = prevState.expandedIndex === index ? null : index;

      return {
        ...prevState,
        expandedIndex: newExpandedIndex,
        expandedAccordions: {
          ...prevState.expandedAccordions,
          [index]:
            newExpandedIndex !== null
              ? {
                  severity: true,
                  summary: true,
                  references: true,
                  migration_patches: true,
                  exploits: true,
                  vector: true,
                  cwe_id: true,
                }
              : {},
        },
      };
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
  
    // Force input reset so same file triggers onChange again
    event.target.value = null;
  
    if (!file) return;
  
    // Clear all previous data and reset UI
    setState((prevState) => ({
      ...prevState,
      selectedFile: file,
      bulkCveError: "",
      bulkCveResponse: null,      // Clear old data
      showScoreContainer: false,  // Hide old scores
      expandedIndex: null,        // Collapse rows
      isBulkFetching: false,      // Ensure "View Details" is visible
    }));
  };
  
  
  const importFileUploaded = async () => {
    if (!state.selectedFile) {
      setState((prevState) => ({
        ...prevState,
        bulkCveError: "No file uploaded. Please select a valid file.",
      }));
      return;
    }

    setState((prevState) => ({
      ...prevState,
      bulkCveError: "",
      bulkCveResponse: null,
      showScoreContainer: false,
      expandedIndex: null,
      isBulkFetching: true,
    }));

    try {
      const file = state.selectedFile;
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (
        fileExtension !== "csv" &&
        fileExtension !== "xlsx" &&
        fileExtension !== "xls"
      ) {
        setState((prevState) => ({
          ...prevState,
          bulkCveError: "Please upload a valid CSV or XLSX file.",
          isBulkFetching: false,
        }));
        return;
      }

      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64data = reader.result.split(",")[1];

        const body = {
          cveData: base64data,
          fileType: fileExtension,
        };

        // Send the data to the backend
        const response = await fetchBulkCVEs(body);
        if (response.success) {
          setState((prevState) => ({
            ...prevState,
            bulkCveResponse: response.data,
            showScoreContainer: true,
            isBulkFetching: false,
          }));
        } else {
          setState((prevState) => ({
            ...prevState,
            bulkCveError: response.message,
            isBulkFetching: false,
          }));
        }
      };
      reader.readAsDataURL(file);
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        bulkCveError: "Error importing file",
        isBulkFetching: false,
      }));
    }
  };

  // … your hooks and handlers above

const renderAccordionDetails = (data, index, options = {}) => {
  const { wrapInCollapse = true } = options;

  const accordions = [
    {
      key: "severity",
      label: "Severity Level",
      value: data.severity,
      tooltip:
        "Describes how serious the vulnerability is (Low, Medium, High, Critical)",
    },
    {
      key: "summary",
      label: "Summary",
      value: data.summary,
      tooltip:
        "A short description of what the vulnerability is and how it affects the system.",
    },
    {
      key: "references",
      label: "References",
      value: data.references,
      tooltip:
        "Links to official reports, security advisories, or research papers",
    },
    {
      key: "migration_patches",
      label: "Migration & Patches",
      value: data.migration_patches,
      tooltip:
        "Steps or updates provided by vendors to fix or reduce the risk of the vulnerability.",
    },
    {
      key: "exploits",
      label: "Exploits",
      value: data.exploits,
      tooltip:
        "Code or methods hackers can use to take advantage of the vulnerability.",
    },
    {
      key: "vector",
      label: "Vector",
      value: data.vector,
      tooltip:
        "Explains how the attack works (e.g., local access, network attack, etc.)",
    },
    {
      key: "cwe_id",
      label: "CWE ID",
      value: data.cwe_id,
      tooltip: "A category that classifies the type of vulnerability.",
    },
  ]
    .map(({ key, label, value, tooltip }) => {
      if (
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0) ||
        value === ""
      ) {
        return null;
      }

      return (
        <BulkCustomAccordion
          key={key}
          expanded={state.expandedAccordions[index]?.[key] || false}
          onChange={() => handleBulkAccordionChange(index, key)}
        >
          <BulkCustomAccordionSummary
            expandIcon={
              <IconWrapper
                src={
                  state.expandedAccordions[index]?.[key]
                    ? MinusIcon
                    : ExpandMoreIcon
                }
                alt="Toggle"
              />
            }
          >
            <BulkCustomTypography
              expanded={state.expandedAccordions[index]?.[key]}
            >
              <Tooltip title={tooltip} placement="top">
                {label}
              </Tooltip>
            </BulkCustomTypography>
          </BulkCustomAccordionSummary>
          <BulkCustomAccordionDetails>
            {Array.isArray(value) && key === "references" ? (
              <ReferencesContainer>
                {value.map(
                  (ref, idx) =>
                    ref.url && (
                      <ReferenceItem key={idx}>
                        <ReferenceLink
                          href={ref.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {ref.url}
                        </ReferenceLink>
                      </ReferenceItem>
                    )
                )}
              </ReferencesContainer>
            ) : Array.isArray(value) && key === "exploits" ? (
              <div>
                {value.map((exploit, idx) => (
                  <AccordionSummaryValues key={idx} variant="body2">
                    {exploit.value}
                  </AccordionSummaryValues>
                ))}
              </div>
            ) : (
              <AccordionSummaryValues>{value}</AccordionSummaryValues>
            )}
          </BulkCustomAccordionDetails>
        </BulkCustomAccordion>
      );
    })
    .filter(Boolean);

  if (wrapInCollapse) {
    return (
      <Collapse
        in={state.expandedIndex === index}
        timeout="auto"
        unmountOnExit
      >
        {accordions}
      </Collapse>
    );
  }

  return <div>{accordions}</div>;
};


  return (
    <>
      <HeaderBoxNew
        showScoreContainer={state.showScoreContainer}
        tabValue={state.tabValue}
      >
        <HeaderContainer />
        <TextContainer>
          {/* <TitleText>Risk Calculator</TitleText> */}
         <TitleText>Risk Calculator
           <BetaText>BETA</BetaText>
          </TitleText>

          <SubTitle>
          Get a unified risk score for a single or bulk set of CVEs{" "}
          <span className="lineBreak">
            using first.org’s Exploit Prediction Scoring System (EPSS).
          </span>
        </SubTitle>

        </TextContainer>
        <ButtonGroupStyled tabValue={state.tabValue}>
          <StyledButton
            active={state.tabValue === 0}
            onClick={() => {
              navigate("/?cve-tab=single-cve");
              setState({ ...state, tabValue: 0 });
            }}
          >
            Single CVE
          </StyledButton>
          <StyledButton
            active={state.tabValue === 1}
            onClick={() => {
              navigate("/?cve-tab=bulk-cve");
              setState({ ...state, tabValue: 1 });
            }}
          >
            Bulk CVE
          </StyledButton>
        </ButtonGroupStyled>


          <MainContentBox tabValue={state.tabValue}>
            {state.tabValue === 0 && (
              <>
                <CveTitleText>CVE ID</CveTitleText>
                <InputField
                  variant="outlined"
                  placeholder="E.g. CVE-2022-3569"
                  fullWidth
                  value={state.cve_id}
                  onChange={(e) =>
                    setState({ ...state, cve_id: e.target.value })
                  }
                />
                {state.singleCveError && (
                  <SingleCveErrorText>
                    {state.singleCveError}
                  </SingleCveErrorText>
                )}

                {/* {state.singleCveError && <ErrorText>{state.singleCveError}</ErrorText>} */}
                {state.singleCveResponse ? (
                  <SingleCveScoreContainer>
                    
                    <Typography className="score cprScore">
                      <span className="scoreValue">
                        {state.singleCveResponse.severity_score}
                      </span>
                      <span className="scoreText">Severity Score <br/>  (CVSS, 1-10 range)</span>
                    </Typography>
                    <span className="score epssScore">
                      <span className="scoreValue">
                        {state.singleCveResponse.epss}
                      </span>
                      <span className="scoreText"> Exploit Probability <br/>(EPSS, 0-1 range)</span>
                    </span>
                  </SingleCveScoreContainer>
                ) : (
                  <FetchButton onClick={handleFetch} disabled={state.isSingleFetching}>
                    {state.isSingleFetching ? (
                      <>
                        <CircularProgress size={16} sx={{ color: '#000', mr: 1 }} />
                        Loading...
                      </>
                    ) : (
                      'View Details'
                    )}
                  </FetchButton>
                )}
              </>
            )}

            {state.tabValue === 1 && (
              <>
                <BulkUploadInputLabel >
                  Bulk CVE File
                </BulkUploadInputLabel>
                <UploadButton component="label">
                  <span className={`file-name ${!state.selectedFile ? "placeholder" : ""}`}>
                    {state.selectedFile ? state.selectedFile.name : "Browse"}
                  </span>
                  <img
                    src={uploadIcon}
                    alt="Upload Icon"
                    className="upload-icon"
                  />
                  <input
                    type="file"
                    hidden
                    accept=".csv, .xlsx, .xls"
                    onChange={handleFileChange}
                  />
                  
                </UploadButton>
                <DownloadLinks>
                  <DownloadLinks>
                    <NoUnderlineLink href={Excel_template} download>
                      <DownloadLinkLabel>Excel Template</DownloadLinkLabel>
                    </NoUnderlineLink>
                    <NoUnderlineLink href={CSV_template} download>
                      <DownloadLinkLabel>CSV Template</DownloadLinkLabel>
                    </NoUnderlineLink>
                  </DownloadLinks>
                </DownloadLinks>
                {state.bulkCveError && (
                  <BulkCveErrorText>{state.bulkCveError}</BulkCveErrorText>
                )}

             {/* Show "View Details" only when no scores yet */}
             {!state.showScoreContainer && (
                <FetchButton
                  onClick={() => importFileUploaded()}
                  disabled={state.isBulkFetching}
                >
                  {state.isBulkFetching ? (
                    <>
                      <CircularProgress size={16} sx={{ color: "#FFF", mr: 1 }} />
                      Loading...
                    </>
                  ) : (
                    "View Details"
                  )}
                </FetchButton>
              )}


                {state.showScoreContainer && state.bulkCveResponse && (
                  <BulkScoreContainer>
                    <Typography className="score cprScore">
                      <span className="scoreValue">
                        {state.bulkCveResponse?.average_severity_score}
                      </span>
                      <span className="scoreText"> Average Severity Score <br/>(CVSS, 1-10 range)</span>
                    </Typography>
                    <span className="score epssScore">
                      <span className="scoreValue">
                        {state.bulkCveResponse?.average_epss_score}
                      </span>
                      <span className="scoreText">Average Exploit Probability<br/> (EPSS, 0-1 range)</span>
                    </span>
                  </BulkScoreContainer>
                )}

                {/* Commented out Firebase dialog - not currently in use */}
                {/* <SimpleDialog
                  selectedValue={selectedValue}
                  open={open}
                  onClose={handleClose}
                /> */}
              </>
            )}
          </MainContentBox>

      {/* Single CVE Details */}
      {state.tabValue === 0 && state.singleCveResponse && (
        <CenteredTableContainer sx={{marginTop:"5rem !important"}}>
          <div
            style={{
              width: "80%",
              maxWidth: "1440px",
              margin: "0 auto 30px",
            }}
          >
            {renderAccordionDetails(state.singleCveResponse, 0, {
              wrapInCollapse: false,
            })}
          </div>
        </CenteredTableContainer>
      )}

      {state.tabValue === 1 &&
        state.showScoreContainer &&
        state.bulkCveResponse &&
        state.bulkCveResponse.cve_data &&
        Array.isArray(state.bulkCveResponse.cve_data) &&
        state.bulkCveResponse.cve_data.length > 0 && (
          <CenteredTableContainer>
            <StyledTable>
              <TableHead>
                <StyledTableRow>
                  <StyledTableHeadCell first>CVE ID</StyledTableHeadCell>
                  <StyledTableHeadCell last>CVSS Score</StyledTableHeadCell>
                  <StyledTableHeadCell middle>EPSS Score</StyledTableHeadCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {state.bulkCveResponse?.cve_data.map((cveData, index) => (
                  <React.Fragment key={index}>
                    <TableRow
                      onClick={() => handleExpandClick(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <StyledTableBodyCell
                        isFirst={true}
                        bold={state.expandedIndex === index}
                        noBottomBorder={state.expandedIndex === index}
                        isLast={index === state.bulkCveResponse.length - 1}
                        expandedIndex={state.expandedIndex}
                        index={index}
                      >
                        {cveData.cve_id}
                      </StyledTableBodyCell>
                     
                      <StyledTableBodyCell
                        bold={state.expandedIndex === index}
                        noBottomBorder={state.expandedIndex === index}
                        isLast={index === state.bulkCveResponse.length - 1}
                        expandedIndex={state.expandedIndex}
                        index={index}
                      >
                        {cveData.severity_score}
                      </StyledTableBodyCell>
                      <StyledTableBodyCell
                        bold={state.expandedIndex === index}
                        noBottomBorder={state.expandedIndex === index}
                        isLast={
                          true || index === state.bulkCveResponse.length - 1
                        }
                        expandedIndex={state.expandedIndex}
                        index={index}
                      >
                        {cveData.epss}
                      </StyledTableBodyCell>
                      <StyledTableBodyCell isToggleColumn={true}>
                        <ToggleIconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            handleExpandClick(index);
                          }}
                        >
                          <IconImage
                            src={
                              state.expandedIndex === index
                                ? downArrowIcon
                                : leftArrowIcon
                            }
                            alt="Toggle"
                          />
                        </ToggleIconButton>
                      </StyledTableBodyCell>
                    </TableRow>

                    {/* Expandable details */}
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                      >
                        <Collapse
                          in={state.expandedIndex === index}
                          timeout="auto"
                          unmountOnExit
                        >
                          {[
                            {
                              key: "severity",
                              label: "Severity Level",
                              value: cveData.severity,
                              tooltip:
                                "Describes how serious the vulnerability is (Low, Medium, High, Critical)",
                            },
                            {
                              key: "summary",
                              label: "Summary",
                              value: cveData.summary,
                              tooltip:
                                "A short description of what the vulnerability is and how it affects the system.",
                            },
                            {
                              key: "references",
                              label: "References",
                              value: cveData.references,
                              tooltip:
                                "Links to official reports, security advisories, or research papers",
                            },
                            {
                              key: "migration_patches",
                              label: "Migration & Patches",
                              value: cveData.migration_patches,
                              tooltip:
                                "Steps or updates provided by vendors to fix or reduce the risk of the vulnerability.",
                            },
                            {
                              key: "exploits",
                              label: "Exploits",
                              value: cveData.exploits,
                              tooptip:
                                "Code or methods hackers can use to take advantage of the vulnerability.",
                            },
                            {
                              key: "vector",
                              label: "Vector",
                              value: cveData.vector,
                              tooltip:
                                "Explains how the attack works (e.g., local access, network attack, etc.)",
                            },
                            {
                              key: "cwe_id",
                              label: "CWE ID",
                              value: cveData.cwe_id,
                              tooltip:
                                "A category that classifies the type of vulnerability.",
                            },
                          ].map(({ key, label, value, tooltip }) => {
                            if (
                              value === null ||
                              value === undefined ||
                              (Array.isArray(value) && value.length === 0) ||
                              value === ""
                            ) {
                              return null;
                            }

                            return (
                              <BulkCustomAccordion
                                key={key}
                                expanded={
                                  state.expandedAccordions[index]?.[key] ||
                                  false
                                }
                                onChange={() =>
                                  handleBulkAccordionChange(index, key)
                                }
                              >
                                <BulkCustomAccordionSummary
                                  expandIcon={
                                    <IconWrapper
                                      src={
                                        state.expandedAccordions[index]?.[key]
                                          ? MinusIcon
                                          : ExpandMoreIcon
                                      }
                                      alt="Toggle"
                                    />
                                  }
                                >
                                  <BulkCustomTypography
                                    expanded={
                                      state.expandedAccordions[index]?.[key]
                                    }
                                  >
                                    <Tooltip title={tooltip} placement="top">
                                      {label}
                                    </Tooltip>
                                  </BulkCustomTypography>
                                </BulkCustomAccordionSummary>
                                <BulkCustomAccordionDetails>
                                  {Array.isArray(value) &&
                                  key === "references" ? (
                                    <ReferencesContainer>
                                      {value.map(
                                        (ref, idx) =>
                                          ref.url && (
                                            <ReferenceItem key={idx}>
                                              <ReferenceLink
                                                href={ref.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                {ref.url}
                                              </ReferenceLink>
                                            </ReferenceItem>
                                          )
                                      )}
                                    </ReferencesContainer>
                                  ) : Array.isArray(value) &&
                                    key === "exploits" ? (
                                    <div>
                                      {value.map((exploit, idx) => (
                                        <AccordionSummaryValues
                                          key={idx}
                                          variant="body2"
                                        >
                                          {exploit.value}
                                        </AccordionSummaryValues>
                                      ))}
                                    </div>
                                  ) : (
                                    <AccordionSummaryValues>
                                      {value}
                                    </AccordionSummaryValues>
                                  )}
                                </BulkCustomAccordionDetails>
                              </BulkCustomAccordion>
                            );
                          })}
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </StyledTable>
          </CenteredTableContainer>
        )}

      
      </HeaderBoxNew>

    </>
  );
};

export default MainComponent;
